/**
 *  @class
 *  @function Cart
 */
class Cart {

  constructor() {
    this.container = document.getElementById('Cart');
    this.setupEventListeners();
        this.setupFormValidation();

  }
  onChange(event) {
    if (event.target.type == 'number') {
      this.updateQuantity(event.target.dataset.index, event.target.value);
    } else if (event.target.getAttribute('id') == 'CartSpecialInstructions') {
      this.saveNotes();
    } else if (event.target.getAttribute('id') == 'GiftWrapping') {
      this.saveGiftWrapping();
    } else if (event.target.getAttribute('id') == 'CourierNotes') {
      this.saveCourierNotes();
    }else if (event.target.matches('.require-if-active')) {
      // Check if it's a dynamically required field
      this.saveRequiredFields(event.target);
    }
  }
  saveNotes() {
    fetch(`${theme.routes.cart_update_url}.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': `application/json`
      },
      body: JSON.stringify({
        'note': document.getElementById('CartSpecialInstructions').value
      })
    }); 
  }
  saveGiftWrapping() {
    const giftWrappingChecked = document.getElementById('GiftWrapping').checked ? "Yes" : "No";
  
    fetch(`${theme.routes.cart_update_url}.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': `application/json`
      },
      body: JSON.stringify({
        'attributes': {
          'Gift Wrapping': giftWrappingChecked
        }
      })
    });
  }
  saveCourierNotes() {
    const courierNotes = document.getElementById('CourierNotes').value;
  
    fetch(`${theme.routes.cart_update_url}.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': `application/json`
      },
      body: JSON.stringify({
        'attributes': {
          'Courier Notes': courierNotes
        }
      })
    });
  }

  // Save dynamically required fields
  saveRequiredFields(field) {
    const requiredPair = field.getAttribute('data-require-pair');
    const pairedRadio = document.querySelector(requiredPair);

    if (pairedRadio && pairedRadio.checked) {
      const fieldValue = field.value;
      const attributeName = field.getAttribute('name');
      const attributeData = {
        'attributes': {
          [attributeName]: fieldValue
        }
      };

      // Update this specific attribute in the cart
      fetch(`${theme.routes.cart_update_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        body: JSON.stringify(attributeData)
      });
    }
  }

  // New method to setup form validation
  setupFormValidation() {
    const form = this.container.querySelector('form[action="/cart"]');
    const invoiceRadio = document.getElementById('choice-at-timologio');
    const requiredFields = document.querySelectorAll('.require-if-active');

    if (form) {
      form.addEventListener('submit', (event) => {
        // Check if invoice option is selected
        if (invoiceRadio && invoiceRadio.checked) {
          // Reset previous error states
          requiredFields.forEach(field => {
            field.classList.remove('error');
          });
          
          // Flag to track validation
          let isValid = true;
          
          // Validate each required field
          requiredFields.forEach(field => {
            if (!field.value.trim()) {
              field.classList.add('error');
              isValid = false;
            }
          });
          
          // Prevent form submission if validation fails
          if (!isValid) {
            event.preventDefault();
            
            // Optional: Show error message
            alert('Παρακαλώ συμπληρώστε όλα τα πεδία για το τιμολόγιο.');
            
            // Focus on the first empty field
            const firstErrorField = document.querySelector('.require-if-active.error');
            if (firstErrorField) {
              firstErrorField.focus();
            }
          }
        }
      });

      // Optional: Add real-time validation as user types
      requiredFields.forEach(field => {
        field.addEventListener('input', () => {
          if (invoiceRadio.checked) {
            if (field.value.trim()) {
              field.classList.remove('error');
            } else {
              field.classList.add('error');
            }
          }
        });
      });
    }
  }
  
  setupEventListeners() {
    this.removeProductEvent();

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    document.addEventListener('cart:refresh', (event) => {
      this.refresh();

      // Reapply form validation after cart refresh
      this.setupFormValidation();
      
    });

    this.container.addEventListener('change', this.debouncedOnChange.bind(this));
    this.termsCheckbox();

      // Add form validation on initial load
    this.setupFormValidation();
  }

  getSectionsToRender() {
    return [{
      id: 'Cart',
      section: 'main-cart',
      selector: '.thb-cart-form'
    },
    {
      id: 'cart-drawer-toggle',
      section: 'cart-bubble',
      selector: '.thb-item-count'
    }];
  }
  displayErrors(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) {
      lineItemError.removeAttribute('hidden');
      lineItemError.querySelector('.cart-item__error-text').innerHTML = message;
      this.container.querySelector(`#CartItem-${line}`).classList.remove('loading');
    }
  }
  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
  updateQuantity(line, quantity) {

    this.container.classList.add('cart-disabled');
    if (line) {
      this.container.querySelector(`#CartItem-${line}`).classList.add('loading');
    }

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });
    dispatchCustomEvent('line-item:change:start', {
      quantity: quantity
    });
    fetch(`${theme.routes.cart_change_url}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': `application/json`
      },
      ...{
        body
      }
    })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);


        if (parsedState.errors) {
          this.displayErrors(line, parsedState.errors);
          this.container.classList.remove('cart-disabled');
          return;
        }

        this.renderContents(parsedState, line, false);

        this.container.classList.remove('cart-disabled');

        dispatchCustomEvent('line-item:change:end', {
          quantity: quantity,
          cart: parsedState
        });
      });
  }
  refresh() {
    this.container.classList.add('cart-disabled');

    let sections = 'main-cart';

    fetch(`${window.location.pathname}/?sections=${sections}`)
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);


        if (parsedState.errors) {
          this.displayErrors(line, parsedState.errors);
          this.container.classList.remove('cart-disabled');
          return;
        }

        this.renderContents(parsedState, false, true);

        this.container.classList.remove('cart-disabled');
      });
  }

 /*termsCheckbox() {
    let terms_checkbox = this.container.querySelector('#CartTerms'),
      checkout_button = this.container.querySelector('.button.checkout-button');

    if (terms_checkbox && checkout_button) {
      terms_checkbox.setCustomValidity(theme.strings.requiresTerms);
      checkout_button.addEventListener('click', function (e) {
        if (!terms_checkbox.checked) {
          terms_checkbox.reportValidity();
          terms_checkbox.focus();
          e.preventDefault();
        }
      });
    }
  }*/

  termsCheckbox() {
  let terms_checkbox = this.container.querySelector('#CartTerms'),
      checkout_button = this.container.querySelector('.button.checkout-button'),
      invoiceRadio = document.getElementById('choice-at-timologio'),
      requiredFields = this.container.querySelectorAll('.require-if-active');

  if (terms_checkbox && checkout_button) {
    terms_checkbox.setCustomValidity(theme.strings.requiresTerms);
    checkout_button.addEventListener('click', (e) => {
      // Reset previous error states
      requiredFields.forEach(field => {
        field.classList.remove('error');
      });

      // Check if invoice option is selected
      if (invoiceRadio && invoiceRadio.checked) {
        let isValid = true;

        // Validate required fields
        requiredFields.forEach(field => {
          if (!field.value.trim()) {
            field.classList.add('error');
            isValid = false;
          }
        });

        // If required fields are not valid, prevent checkout
        if (!isValid) {
          e.preventDefault();
          alert('Παρακαλώ συμπληρώστε όλα τα πεδία για το τιμολόγιο.');
          
          // Focus on the first empty field
          const firstErrorField = this.container.querySelector('.require-if-active.error');
          if (firstErrorField) {
            firstErrorField.focus();
          }
          return;
        }
      }

      // Check terms checkbox
      if (!terms_checkbox.checked) {
        terms_checkbox.reportValidity();
        terms_checkbox.focus();
        e.preventDefault();
      }
    });
  }
}
  
  
  removeProductEvent() {
    let removes = this.container.querySelectorAll('.remove');

    removes.forEach((remove) => {
      remove.addEventListener('click', (event) => {
        this.updateQuantity(event.target.dataset.index, '0');

        event.preventDefault();
      });
    });
  }
  renderContents(parsedState, line, refresh) {
    this.getSectionsToRender().forEach((section => {
      const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

      if (refresh) {
        if (parsedState[section.section]) {
          elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState[section.section], section.selector);
        }
      } else {
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
      }

      this.removeProductEvent();

      if (line && this.container.querySelector(`#CartItem-${line}`)) {
        this.container.querySelector(`#CartItem-${line}`).classList.remove('loading');
      }
      this.termsCheckbox();
      
    }));
  }
}

// Add some CSS for error states
const styleElement = document.createElement('style');
styleElement.textContent = `
  .require-if-active.error {
    border: 2px solid red;
    background-color: #ffeeee;
  }
`;
document.head.appendChild(styleElement);

window.addEventListener('load', () => {
  if (typeof Cart !== 'undefined') {
    new Cart();
  }
});